module.exports = __webpack_public_path__ + "img/buy_usdt_mobile2.2cbd2ccc.png";